import {Injectable} from '@angular/core';
import {ArrayWithDefault, MappedStammdaten} from '@utils-lib';
import {cloneDeep, isNil, set} from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class StammdatenService {

    public stammdaten: MappedStammdaten;

    private static assignStammdatenToTarget(data: any, stammdaten: any | Array<unknown> | ArrayWithDefault<unknown>, target: string): void {

        let value;
        if (Array.isArray(stammdaten) && stammdaten.length === 1) {
            value = stammdaten[0];
        }

        if (!Array.isArray(stammdaten)) {
            value = stammdaten;
        }

        if (stammdaten?.array) {
            if (stammdaten.standardIndex >= 0) {
                value = stammdaten.array[stammdaten.standardIndex];
            } else if (stammdaten.array.length === 1) {
                value = stammdaten.array[0];
            } else {
                value = null;
            }
        }

        if (!isNil(value)) {
            set(data, target, cloneDeep(value));
        }
    }

    public assignStammdatenIfDeterministic(map: Map<string, unknown | Array<unknown>>, data: unknown): void {
        map?.forEach(StammdatenService.assignStammdatenToTarget.bind(this, data));
    }

}
